import gql from 'graphql-tag';

// チェックボックス値取得
export const GET_QUIT_CHECKBOX = gql`
    query {
        withdrawalReasonCheckbox
        {
            id
            reason
        }
    },
`;

// 退会処理
export const ADD_WITHDRSWSLS = gql`
    mutation (
        $reason_other: String,
        $checkbox_reason_id: [Int]
        )
        {
        addWithdrawals (
            reason_other: $reason_other,
            checkbox_reason_id: $checkbox_reason_id
        )
        {
            result
        }
    }
`;
